module.exports = __webpack_public_path__ + "7d088296/img/boston-lights.a623432f.png";